<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <app-trix-base
            v-model="content"
            @change="handleChange"
            v-bind="$attrs"
            class="w-full"
            :class="options"
            slot="input"
        ></app-trix-base>
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import TrixBase from '@/components/TrixBase';

    export default {
        name: 'app-field-trix',

        components: {
            'app-field': Field,
            'app-label': Label,
            'app-trix-base': TrixBase
        },

        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            content: ''
        }),

        mounted() {
            this.content = this.value;
        },

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        methods: {
            handleChange(value) {
                this.content = value;

                this.$emit('input', this.content);
            },
        },

        watch:{
            value(value) {
                this.handleChange(value);
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>


// WEBPACK FOOTER //
// src/components/fields/inputs/Trix.vue